module.exports = __webpack_public_path__ + "static/media/storytelling.50615ebd.svg";